import { render, staticRenderFns } from "./AmostrasCatalisadoresPecaInfo.vue?vue&type=template&id=6e26f3bc&"
import script from "./AmostrasCatalisadoresPecaInfo.vue?vue&type=script&lang=ts&"
export * from "./AmostrasCatalisadoresPecaInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VIcon,VRow})
